/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type SoftwareClassicFeaturesType from '@jira/spa-apps__project-settings-classic-features/src/ClassicFeaturesWithAllInfrastructure.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazySoftwareClassicFeatures: LazyComponent<React.ComponentType<Record<any, any>>> =
	lazyForPaint<typeof SoftwareClassicFeaturesType>(() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-classic-features", jiraSpaEntry:  "async-classic-features" */ '@jira/spa-apps__project-settings-classic-features/src/ProjectSettingsClassicFeatures.tsx'
			),
		),
	);

export const ClassicFeaturesPage = (): React.JSX.Element => (
	<LazyPage Page={LazySoftwareClassicFeatures} pageId="classic-features" shouldShowSpinner />
);
